module.exports = {"450109100":"蒲庙镇","450109101":"那楼镇","450109102":"新江镇","450109103":"百济镇","450109104":"中和镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450109.json
// module id = 2200
// module chunks = 0